import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { useFormContext } from 'react-hook-form';
import { Box /* , Rating */ } from '@mui/material';
// import StarBorder from '@mui/icons-material/StarBorder';
// import StarIcon from '@mui/icons-material/Star';
import {
  userBranchesAtom,
  productsAtom,
  themeAtom,
  practiceProductAtom,
} from '../../../Atoms';
import CheckboxStack from '../../../Components/Inputs/CheckboxStack';
import OccupationSelect from '../../../Components/Inputs/OccupationSelect';
import AgeFilter from './Inputs/AgeFilter';
import CustomToggle from '../../../Components/Inputs/CustomToggle';
import MultipleChipSelect from '../../../Components/Inputs/MultipleChipSelect';
import { WAVE, CHANNELS } from '../Utils/constants';
// import { RATING } from '../../../Utils/constants/general';
import FormTextField from '../../../Components/Form/FormTextField';
import RangeNumbersField from '../../../Components/Inputs/RangeNumbersField';
import FetchAutoComplete from '../../../Components/Inputs/FetchAutoComplete';

const useStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    p: '8px 24px',
  },
  columns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: '32px',
    alignItems: 'start',
  },
  filterCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  toggleRow: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
});

/* const checkboxes = RATING.map((i) => ({
  label: (
    <Rating
      name={`rating${i}`}
      value={i}
      size="large"
      readOnly
      emptyIcon={<StarBorder fontSize="inherit" color="primary" />}
      icon={<StarIcon fontSize="inherit" color="primary" />}
    />
  ),
  value: i,
})); */

/* const fillRating = (newRating) => {
  const rating = [];
  for (let i = 0; i < newRating?.length; i += 1) {
    rating[newRating[i]] = newRating[i];
  }
  return rating;
}; */
const fillSections = (sections, newSections) =>
  sections
    ?.filter(({ id }) => newSections?.find((item) => item === id))
    .map(({ name }) => name);

const fillBranches = (branches, newBranches) =>
  branches
    ?.filter(({ id }) => newBranches?.find((item) => item === id))
    .map(({ branchDescription }) => branchDescription);

const SMSFiltersWidget = function SMSFiltersWidget({
  selectedFilters = null,
  waveSections = [],
}) {
  const classes = useStyles();
  const intl = useIntl();
  const {
    setValue,
    formState: { errors },
  } = useFormContext();
  const currentTheme = useAtomValue(themeAtom);

  const practiceProductOptions = useAtomValue(practiceProductAtom);
  const productsOptions = useAtomValue(productsAtom);
  const branches = useAtomValue(userBranchesAtom);
  const [branch, setBranch] = useState(
    branches?.map(({ branchDescription }) => branchDescription)
  );
  // const [arRating, setArRating] = useState();
  const [waveValue, setWaveValue] = useState(0);
  const [arSections, setArSections] = useState(
    waveSections?.map(({ name }) => name)
  );
  const [occupation, setOccupation] = useState([]);
  const [products, setProducts] = useState([]);
  const [channelValue, setChannelValue] = useState(0);
  const [remainingCustomers, setRemainingCustomers] = useState([null]);
  const [withoutPhoneNumber, setWithoutPhoneNumber] = useState([null]);
  const [installments, setInstallments] = useState({
    value: [],
    exclude: false,
  });
  const [practiceProducts, setPracticeProducts] = useState([]);

  const handleChangeInstallments = (newValue) => {
    setInstallments(newValue);
    setValue(
      'paidInstallments',
      newValue?.range?.length > 0
        ? {
            rawValue: newValue?.rawValue,
            range: newValue?.range,
            exclude: newValue?.exclude,
          }
        : undefined
    );
  };

  const fillFieldsWithDefaultValues = (defaultValuesArray) => {
    if (defaultValuesArray) {
      setChannelValue(defaultValuesArray.isSMS ? 1 : 0);
      setOccupation(defaultValuesArray.occupation || []);
      setBranch(
        fillBranches(branches, defaultValuesArray.branches) ||
          branches.map(({ branchDescription }) => branchDescription)
      );
      // setArRating(fillRating(defaultValuesArray.rating));
      setArSections(fillSections(waveSections, defaultValuesArray?.sections));
      setWaveValue(defaultValuesArray.withWave ? 0 : 1);
      setRemainingCustomers(
        defaultValuesArray.remainingCustomers ? [0] : [null]
      );
      setWithoutPhoneNumber(
        defaultValuesArray.withoutPhoneNumber ? [0] : [null]
      );
      setProducts(
        defaultValuesArray?.products === null
          ? []
          : defaultValuesArray?.products
      );
      setPracticeProducts(
        defaultValuesArray?.practiceProducts === null
          ? []
          : defaultValuesArray?.practiceProducts
      );
      if (defaultValuesArray?.paidInstallments) {
        handleChangeInstallments({
          rawValue: defaultValuesArray.paidInstallments?.rawValue || '',
          range: defaultValuesArray.paidInstallments?.range || [],
          exclude: defaultValuesArray.paidInstallments?.exclude,
        });
      }
    }
    setValue('isSMS', channelValue === 1);
    setValue('withWave', waveValue === 0);
    setValue('campaignName', defaultValuesArray?.campaignName || '');
  };

  useEffect(() => {
    fillFieldsWithDefaultValues(selectedFilters);
  }, [selectedFilters]);

  /**Selects onChange functions**/
  const handleOccupationChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setOccupation([]);
    else {
      setOccupation(value);
    }
  };

  const handleProductChange = (value) => {
    if (!Array.isArray(value) || value?.length === 0) setProducts(null);
    else {
      setProducts(value);
    }
  };

  useEffect(() => {
    setValue('occupation', occupation);
  }, [occupation]);

  useEffect(() => {
    setValue('products', products?.length === 0 ? null : products);
  }, [products]);

  useEffect(() => {
    setValue(
      'practiceProducts',
      practiceProducts?.length === 0 ? null : practiceProducts
    );
  }, [practiceProducts]);

  const handleBranchChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setBranch([]);
    else {
      setBranch(value);
    }
  };

  useEffect(() => {
    const newBranchesValue = branches
      .filter(({ branchDescription }) =>
        branch?.find((item) => item === branchDescription)
      )
      .map(({ id }) => id);
    setValue('branches', newBranchesValue);
  }, [branch]);
  /****/

  /**Checkbox stacks onChange functions**/
  const handleChangeRemainingCustomers = (newValue) => {
    setRemainingCustomers(newValue);
    setValue('remainingCustomers', newValue[0] !== null);
  };

  const handleChangeWithoutPhone = (newValue) => {
    setWithoutPhoneNumber(newValue);
    setValue('withoutPhoneNumber', newValue[0] !== null);
  };

  /*  const handleChangeRating = (newRating) => {
    setArRating(newRating);
    const ratingToSubmit = checkboxes.filter(
      ({ value }) => value === parseInt(newRating[value], 10)
    );
    setValue(
      'rating',
      ratingToSubmit.map(({ value }) => value)
    );
  }; */

  const handleChangeSections = (value) => {
    if (!Array.isArray(value) || value.length === 0) {
      setArSections([]);
      setValue('sections', []);
    } else {
      setArSections(value);
      const newSectionsValue = waveSections
        .filter(({ name }) => value?.find((item) => item === name))
        .map(({ id }) => id);
      setValue('sections', newSectionsValue);
    }
  };

  const handlePracticeProductChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setPracticeProducts(null);
    else {
      setPracticeProducts(value);
    }
  };
  /****/

  /**ToggleSwitch onChange functions and triggers with useEffect**/
  const handleChangeWaveValue = (event, newValue) => {
    setWaveValue(newValue);

    setValue('withWave', newValue === 0);
    if (newValue === 1) {
      handleChangeRemainingCustomers([null]);
      handleChangeSections([]);
    } else {
      handleChangeSections(waveSections.map(({ name }) => name));
    }
  };
  const handleChangeChannel = (event, newValue) => {
    setChannelValue(newValue);
  };

  useEffect(() => {
    setValue('isSMS', channelValue === 1);
    if (channelValue === 1) handleChangeWithoutPhone([null]);
  }, [channelValue]);

  /****/

  return (
    <Box sx={classes.root}>
      <FormTextField
        name="campaignName"
        error={errors?.campaignName}
        required
      />
      <Box sx={classes.columns}>
        <Box sx={classes.filterCol}>
          <Box sx={classes.toggleRow}>
            <CustomToggle
              backgroundColor={
                currentTheme === 'dark' ? 'greys.darker' : '#ededed'
              }
              width="220px"
              tabs={WAVE}
              handleChange={handleChangeWaveValue}
              value={waveValue}
            />
            <CheckboxStack
              data={[
                {
                  label: intl.messages.REMAINING_CUSTOMERS,
                  value: 0,
                  disabled: waveValue === 1,
                },
              ]}
              defaultCheckedAr={remainingCustomers}
              handleChange={handleChangeRemainingCustomers}
            />
          </Box>
          <MultipleChipSelect
            disabled={waveValue === 1}
            options={waveSections.map(({ name }) => name)}
            values={arSections}
            onChange={handleChangeSections}
            label={intl.messages.SECTIONS}
          />
          <MultipleChipSelect
            options={branches.map(({ branchDescription }) => branchDescription)}
            values={branch}
            onChange={handleBranchChange}
            label={intl.messages.BRANCHES}
          />
          <OccupationSelect
            onChange={handleOccupationChange}
            values={occupation}
          />
          <AgeFilter
            defaultMin={selectedFilters?.lowerAge}
            defaultMax={selectedFilters?.upperAge}
          />
        </Box>
        <Box sx={classes.filterCol}>
          <Box sx={classes.toggleRow}>
            <CustomToggle
              backgroundColor={
                currentTheme === 'dark' ? 'greys.darker' : '#ededed'
              }
              width="220px"
              tabs={CHANNELS}
              handleChange={handleChangeChannel}
              value={channelValue}
            />
            <CheckboxStack
              data={[
                {
                  label: intl.messages.PHONE_UNAVAILABLE,
                  value: 0,
                  disabled: channelValue === 1,
                },
              ]}
              defaultCheckedAr={withoutPhoneNumber}
              handleChange={handleChangeWithoutPhone}
            />
          </Box>
          <RangeNumbersField
            name="paidInstallments"
            rangeValue={installments}
            onChangeRangeValue={handleChangeInstallments}
            defaultValue={{
              ...selectedFilters?.paidInstallments,
              exclude: selectedFilters?.paidInstallments?.exclude,
            }}
          />
          <MultipleChipSelect
            label={intl.messages.DESCRIPTION_PRACTICE_PRODUCT}
            onChange={handlePracticeProductChange}
            values={practiceProducts || []}
            options={practiceProductOptions || []}
          />
          <FetchAutoComplete
            id="offer-type-autocomplete"
            label={intl.messages.OFFER_TYPE}
            placeholder={`${intl.messages.INSERT} ${intl.messages.OFFER_TYPE}`}
            multiple
            selectedValue={products || []}
            onChangeSelectedValue={(event, newValue) =>
              handleProductChange(newValue)
            }
            staticOptions={
              productsOptions?.length > 0 ? productsOptions : products || []
            }
            noCustomValue
            getOptionLabel={(option) => option}
          />
        </Box>
      </Box>
    </Box>
  );
};

SMSFiltersWidget.propTypes = {
  selectedFilters: PropTypes.object,
  waveSections: PropTypes.array,
};

export default SMSFiltersWidget;
